import React, { useState, useCallback, useEffect,useRef } from 'react';
import HeaderNonSrp from '../header/headerNonSrp';
import SubHeader from '../header/subHeader';
import GInput from '../common/input/ginput';
import { baseCss } from "../common/css";
import { renderImg } from '../common/icons/img';
import Footer from '../footer/footer';
import AccountLoader from '../manageAccount/accountLoader';
import { apiUrl } from '../common/constants';
import { GetRequest, PostRequest, getparamsString } from '../common/helper';
import AlertFail from '../common/alertFail';
import Alert from '../common/alert';
import CancelRequestForm from '../common/cancelRequestForm';
import AlertSuccess from '../common/alertSuccess';
import { t, CANCEL_TICKET_FOR_BUS_BOOKING, YOU_ARE_GUEST, PNR_NUMBER, TRANSACTION_PASSWORD, MOBILE_NUMBER, SEARCH, PLEASE_ENTER_VALID_DETAILS,CNTRY_CODE,ENT_CC} from '../../translations/GuestCancel';
import GoogleRecaptchaV3 from '../common/GoogleRecaptchaV3';
import { RECAPTCHA_FAIL, RECAPTCHA_LOADING, t as tLogin } from '../../translations/Login';
import AlertTxnPwd from '../common/alertTxnPwd';
import { Search } from '../common/icons/svg';


const GuestCancel = () => {
   const params = new URLSearchParams(window.location.search);
   const [pnr, setPnr] = useState(params.get('pnr') || "");
   const [pwd, setPwd] = useState("");
   const [mobile, setMobile] = useState("");
   const [loader, setLoader] = useState(false);
   const [bookingData, setBookingData] = useState(false);
   const [isCancelled, setCancelled] = useState(false);
   const [journeyDateOver, setJourneyDateOver] = useState(false);
   const [errMsg, setErrorMsg] = useState("");
   const [cancelRequest, setCancelRequest] = useState(false);
   const [cancelRequestSucess, setCancelRequestSuccess] = useState(false);
   const [cancelRequestFail, setCancelRequestFail] = useState(false);
   const [remark, setRemark] = useState("");
   const [cancelRequestMsg, setCancelRequestMsg] = useState("");
   const [loggedUserMsg, setLoggedUserMsg] = useState(false);
   const [token, setToken] = useState("");
   const [refreshReCaptcha, setRefreshReCaptcha] = useState(false);
   const [requestTxnPwd, setRequestTxnPwd] = useState(false);
   const [txnPwdUpdated, setTxnPwdUpdated] = useState(false);
   const [txnData, setTxnData] = useState(false);
   const [ccdata,setccData] = useState({code:'+91',name:'India'});
   const [showDropFrCountryCode,setShowDropFrCountryCode] = useState(false);
   const [searchCountryCode,setSearchCountryCode] = useState("");
   const [filterCountryData,setFilterCountryData] = useState([]);
   const [countryData,setCountryData] = useState([]);
   const dropdownRef = useRef();

   useEffect(()=>{
       getCountryDetails();
   },[])

   //  useEffect(() => {
   //      // Add event listener to detect clicks outside
   //      document.addEventListener("mousedown", handleClickOutside);

   //      // Cleanup event listener on component unmount
   //      return () => {
   //          document.removeEventListener("mousedown", handleClickOutside);
   //      };
   //  }, []);

   
   // const handleClickOutside = (event) => {
   //    if (!event.target.closest('all-data-opt.active')) {
   //       setShowDropFrCountryCode(false);
   //    }
   // };

   const valiDateDtl = () => {
      // console.log(ccdata.code);
      if (!pnr) {
         setErrorMsg("Please Enter Pnr");
         return false;
      }
      if(ccdata.code == '+91'){
         if (!mobile || String(mobile).length < 10 ) {
           setErrorMsg("Please Enter Mobile No");
           return false;
         }
      }else{
         if (!mobile || String(mobile).length < 6 ) {
             setErrorMsg("Please Enter valid International Mobile No");
             return false;
         }
      }
      if (!pwd) {
         setErrorMsg("Please Enter Txn Password");
         return false;
      }
      if (pwd && pwd.length < 4) {
         setErrorMsg("Txn Password must be at least 4 characters long.");
         return false;
      }
      return true;
   };

   const pnrValidated = () => {
      if(valiDateDtl()){
           setLoader(true);
            const url = `${apiUrl.validPnr}?pnr=${pnr}`;
            GetRequest(url)
               .then((response) => {
                  setLoader(false);
                  if (response.Success) {
                     checkTxnPwd()
                  } else {
                     setErrorMsg("Please enter valid pnr")
                     setLoader(false);
                  }
               })
               .catch(() => { setLoader(false) });
      }
   }


   const checkTxnPwd = () => {
      let cc = ccdata.code.replace(/\+/g, "");
      setLoader(true);
      const url = `${apiUrl.validateTxnPwd}?pnr=${pnr}&txnPwd=${pwd}&mobile=${mobile}&countryCode=${cc}`;
      // console.log("url",url);
      GetRequest(url)
         .then((response) => {
            setLoader(false);
            if (response.Success) {
               checkLogginBooking();
            } else {
               // setErrorMsg(t(PLEASE_ENTER_VALID_DETAILS))
               setRequestTxnPwd(true);
               setLoader(false);
            }
         })
         .catch(() => { setLoader(false) });
   }

   const getCountryDetails = () => {
      setLoader(true);
      const url = `${apiUrl.getcountryCode}`;
      GetRequest(url)
         .then((response) => {
            setLoader(false);
            let countryData = response.CountriesResult;
            setCountryData(countryData);
            setFilterCountryData(countryData)
           
         })
         .catch(() => { setLoader(false) });
   };

   const checkLogginBooking = () => {
      setLoader(true);
       let mob = mobile;
       let cc = ccdata.code.replace(/\+/g, "");
       if(cc == '91'){
         mob = mobile;
       }else{
         mob = cc + mobile;
       }

      const url = `${apiUrl.getBookingByUserId}?pnr=${pnr}&mobile=${mob}`;
      GetRequest(url)
         .then((response) => {
            setLoader(false);
            if (response.uid != null && parseInt(response.uid) > 0) {
               setLoggedUserMsg(true);
               return;
            } else {
               setLoader(false);
               getPnrDetail();
            }
         })
         .catch(() => { setLoader(false) });
   };

   const getPnrDetail = async () => {
      if (valiDateDtl()) {
         const captchaRes = await verifyRecaptcha();
         refreshCaptchaToken();
         if (!captchaRes?.Success) {
            setErrorMsg(captchaRes?.ErrorMessage || tLogin(RECAPTCHA_FAIL));
            return;
         }
         setLoader(true);
         if (pnr) {
            setLoader(true);
            let mob = mobile;
            let cc = ccdata.code.replace(/\+/g, "");
            if(cc == '91'){
               mob = mobile;
            }else{
               mob = cc + mobile;
            }
            const data = {
               PNR: pnr,
               mobile: mob,
            };
            const url = apiUrl.bookingInfo + "?" + getparamsString(data);
            GetRequest(url)
               .then((res) => {
                  setLoader(false);
                  if (res.Status && !res.Error) {
                     let bookingInfo = res.BookingInfo.APIGetBookingDetailsResult[0];
                     setBookingData(
                        bookingInfo
                     );

                     if (bookingInfo.IsCancelReqApplicable == 1) {
                        setCancelRequest(true);
                        return;
                     }

                     //if booking status is booked but service cancled then also able to cancel ticket
                     if (bookingInfo.BookingStatus === 'B' && bookingInfo.IsServiceCancel === '1'){
                        window.location.href = `/guest-cancel-confirm?pnr=${bookingInfo.BookingRefNo}&mobile=${mob}`;
                        return;
                     }

                     if (bookingInfo.BookingStatus === 'B' && (new Date(window.currentDateTime).getTime() >= new Date(bookingInfo.DptTime).getTime())) {
                        setJourneyDateOver(true);
                        return;
                     }

                     if (bookingInfo.BookingStatus === 'B') {
                        window.location.href = `/guest-cancel-confirm?pnr=${bookingInfo.BookingRefNo}&mobile=${mob}`
                        return;
                     }
                     
                     if (bookingInfo.BookingStatus === 'C') {
                        setCancelled(true);
                     }
                  } else {
                     if (res.Error) {
                        setErrorMsg(res.Error)
                     }
                  }
               })
               .catch((err) => {
                  setLoader(false);
                  console.log(err);
               });
         }
      }
   }

   const submitCancelRequest = async () => {
      if (remark !== "" && remark.length >= 4) {
         let postData = {
            PNR: bookingData.BookingRefNo,
            TranPwd: "",
            MobileNo: bookingData.PassengerContactNo1,
            RequestTypeID: 1,
            Remarks: remark,
         };
         const captchaRes = await verifyRecaptcha();
         refreshCaptchaToken();
         if (!captchaRes?.Success) {
            setErrorMsg(captchaRes?.ErrorMessage || tLogin(RECAPTCHA_FAIL));
            return;
         }
         setLoader(true);
         PostRequest(apiUrl.pnrCancelRequest, postData)
            .then((response) => {
               if (response.ErrorMessage) {
                  setCancelRequest(false);
                  setCancelRequestFail(true);
                  setCancelRequestMsg(response.ErrorMessage)
                  setLoader(false);
               } else {
                  setCancelRequest(false);
                  setCancelRequestSuccess(true)
                  setLoader(false);
               }
            })
            .catch((error) => {
               setLoader(false);
               console.log(error);
            });

      } else {
         // setErrorMsg("Please Enter the remark");
      }

   }

   const onVerify = useCallback((captchaToken) => {
      setToken(captchaToken);
   }, []);

   const refreshCaptchaToken = () => {
      setRefreshReCaptcha((r) => !r);
   };

   const verifyRecaptcha = async () => {
      if (!token) {
         return { Success: false, ErrorMessage: tLogin(RECAPTCHA_LOADING) };
      }
      const data = {
         response: token
      };
      setLoader(true);
      try {
         const res = await PostRequest(apiUrl.validateCaptcha, data);
         setLoader(false);
         return res || { Success: false, ErrorMessage: tLogin(RECAPTCHA_FAIL) };
      } catch (err) {
         setLoader(false);
         return { Success: false, ErrorMessage: tLogin(RECAPTCHA_FAIL) };
      }
   };

   const updateTxnPwd = () => {
      let postData = {
         pnr: pnr
      };
      setLoader(true);
      PostRequest(apiUrl.updateTxnPwd, postData)
         .then((response) => {
            if (response.Success) {
               setLoader(false);
               setTxnData(response.data)
               setRequestTxnPwd(false);
               setTxnPwdUpdated(true);
            }
         })
         .catch((error) => {
            setLoader(false);
            console.log(error);
         });

   }
   const handleccData = (el) =>{
      setccData({code:el.CountryCode,name:el.CountryName})
      setShowDropFrCountryCode(false)
   }

   const handleSearchCountryCode = (searchVal) =>{
      setSearchCountryCode(searchVal);
      if(searchVal && searchVal.length >0){
         const tempList = countryData.filter((el) => {
            return (el.CountryName.toLowerCase().includes(searchVal.toLowerCase()) || el.CountryCode.toLowerCase().includes(searchVal.toLowerCase()));
         });
         setFilterCountryData(tempList);
      }
   }

   return (
      <div className='guest--cancel--wrapper'>
         <HeaderNonSrp />
         <SubHeader />
         {loader && <AccountLoader />}
         <div className="guest--cancel--inputs">
            <div className='guest--cancel--head' style=
               {{
                  color: '#202020',
                  fontWeight: '600',
                  letterSpacing: '0.01rem'
               }}>{t(CANCEL_TICKET_FOR_BUS_BOOKING)}</div>
            <div className='guest--cancel-ntlgn'
               style={{
                  display: 'flex',
                  alignItems: 'center',
                  color: '#444',
                  fontWeight: '500',
                  letterSpacing: '0.02rem',
                  paddingTop: '10px'
               }}
            >
               <div style={{ display: 'flex', alignItems: 'center', marginRight: '8px' }}>{renderImg('exicon')}</div>
               <div>{t(YOU_ARE_GUEST)}</div>
            </div>
            <GInput
               type="text"
               value={pnr}
               onChange={(e) => setPnr(e)}
               errMsg="Enter Pnr Number"
               label={t(PNR_NUMBER)}
               key={"pnr"}
               icon={renderImg('cancel_pnr')}
               // validation="pnr"
               iconError={renderImg("pnr_error")}
            />

            <GInput
               type="text"
               value={pwd}
               onChange={(e) => setPwd(e)}
               errMsg="Enter Transaction Password"
               label={t(TRANSACTION_PASSWORD)}
               key={"password"}
               validation={"txn_password"}
               icon={renderImg("txn_pwd")}
               max={6}
               iconError={renderImg("lock-icon-error")}
            />
         <div className="timetable-input-wrap" style={{position:'relative'}}>
             <GInput
               value={ccdata.code +' '+ ccdata.name}
               errMsg={t(ENT_CC)}
               label={t(CNTRY_CODE)}
               validation="countrycode"
               key={"cc"}
               icon={renderImg("flag-icon")}
               iconError={renderImg("flag-icon-error")}
               readonly={true}
               icon2={renderImg("filter-left-arrow")}
               onClick={() => setShowDropFrCountryCode(true)}
               onIconClick={() => setShowDropFrCountryCode(true)}
        />
          <div
            className={showDropFrCountryCode ? "all-data-opt active" : "all-data-opt"}
          >
            <div className="sel-input-wrap">
              <div className="srch-icn">
                <Search />{" "}
              </div>
              <input
                type="text"
                placeholder={'Search Country Code'}
                value={searchCountryCode}
                onChange={(e) => handleSearchCountryCode(e.target.value)}
              />
              <span
                className="net-drop-up"
                onClick={() => setShowDropFrCountryCode(false)}
              ></span>
            </div>
            <div>
               
            </div>
            <div className="show-all-data scroll" ref={dropdownRef}>
               {filterCountryData.length > 0 && filterCountryData.map((el, index) => {
                return (
                  <div
                    key={el + "-" + index}
                    className={
                      el.CountryCode  === ccdata.code
                        ? " data--list active "
                        : " data--list "
                    }
                    onClick={() => handleccData(el)}
                  >
                    {el.CountryCode} {el.CountryName}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
            <GInput
               type="tel"
               value={mobile}
               onChange={(e) => setMobile(e)}
               validation={ccdata.code == '+91'? "mobile2" : "imobile"}
               errMsg="Enter Valid Mobile Number"
               label={t(MOBILE_NUMBER)}
               key={"mobileno"}
               icon={renderImg("phone-icon")}
               iconError={renderImg("phone-icon-error")}
            />
            <div
               className="btn payee"
               style={baseCss.secondaryBackground}
               onClick={pnrValidated}
            >
               {t(SEARCH)}
            </div>
            {isCancelled &&

               <AlertFail
                  msg={
                     <div
                        className="tnc-block-text"
                        style={{ justifyContent: "center" }}
                     >
                        <div className="icon">
                           {renderImg('fail_icon')}
                        </div>
                        <div className="content" style={{ fontSize: '14px', fontWeight: '500', lineHeight: '22px', color: '#202020' }}>
                           This ticket is already cancelled.
                        </div>
                     </div>
                  }

               />}
            {journeyDateOver &&

               <AlertFail
                  msg={
                     <div
                        className="tnc-block-text"
                        style={{ justifyContent: "center" }}
                     >
                        <div className="icon">
                           {renderImg('fail_icon')}
                        </div>
                        <div className="content" style={{ fontSize: '14px', fontWeight: '500', lineHeight: '22px', color: '#202020' }}>
                           This ticket is no longer cancellable as per the cancellation policy at the time of booking.
                        </div>
                     </div>
                  }

               />}
            {errMsg && (
               <Alert
                  msg={errMsg}
                  error={true}
                  close={() => setErrorMsg("")
                  }
               />
            )}

            {

               loggedUserMsg && <CancelRequestForm
                  msg={
                     <div
                        className="tnc-block-text"
                        style={{ justifyContent: "center" }}
                     >
                        <div className="icon">
                           {renderImg('login_error')}
                        </div>
                        <div className="content" style={{ fontSize: '14px', fontWeight: '500', lineHeight: '22px', color: '#202020' }}>
                           You booked this PNR as registered user therefore please login to cancel this booking
                        </div>
                        <div className="cancel--request--btn" onClick={() => { window.location.href = '/login' }}>go to login</div>
                     </div>
                  }
                  onClick={setLoggedUserMsg}
               />

            }

            {
               cancelRequest &&

               <CancelRequestForm

                  msg={
                     < div
                        className="tnc-block-text"
                        style={{ justifyContent: "center" }}
                     >
                        <GInput
                           type="tel"
                           value={"Cancellation Request"}
                           disabled={true}
                           readonly={true}
                           label="Request Type"
                           validation="mobile"
                        // icon={renderImg("txn_pwd")}
                        />
                        <GInput
                           type="text"
                           value={remark}
                           errMsg="Enter the valid remark"
                           validation="cancel_remark"
                           onChange={(e) => setRemark(e)}
                           label="Remarks"
                           key={"remarks"}
                        />
                        <div className="cancel--request--btn" onClick={submitCancelRequest}>Submit Request</div>
                     </div>
                  }
                  onClick={setCancelRequest}
               />

            }

            {
               cancelRequestSucess &&
               <AlertSuccess
                  msg={
                     <div
                        className="tnc-block-text"
                        style={{ justifyContent: "center" }}
                     >
                        <div className="icon">
                           {renderImg('success_icon')}
                        </div>

                        <div className="content" style={{ fontSize: '14px', fontWeight: '500', lineHeight: '22px', color: '#202020' }}>
                           We have received your Cancellation Request after journey date. We shall review and mail you back on the same.
                        </div>
                     </div>
                  }
               />
            }
            {cancelRequestFail &&

               <AlertFail
                  msg={
                     <div
                        className="tnc-block-text"
                        style={{ justifyContent: "center" }}
                     >
                        <div className="icon">
                           {renderImg('login_error')}
                        </div>
                        <div className="content" style={{ fontSize: '14px', fontWeight: '500', lineHeight: '22px', color: '#202020' }}>
                           {cancelRequestMsg || 'You have already raised a cancellation request for this PNR which is under process at KSRTC end.'}
                        </div>
                     </div>
                  }

               />}
            {requestTxnPwd &&

               <AlertTxnPwd
                  setRequestTxnPwd={setRequestTxnPwd}
                  updateTxnPwd={updateTxnPwd}
                  msg={
                     <div
                        className="tnc-block-text"
                        style={{ justifyContent: "center" }}
                     >
                        <div className="content" style={{ fontSize: '14px', fontWeight: '500', lineHeight: '22px', color: '#202020' }}>
                           {'Transaction Password has expired. Please request a new Transaction Password on your email and SMS associated with your booking and retry.'}
                        </div>
                     </div>
                  }

               />}
            {txnPwdUpdated && <AlertSuccess
               type={'txn_pwd'}
               close={() => setTxnPwdUpdated(false)}
               msg={
                  <div
                     className="tnc-block-text"
                     style={{ justifyContent: "center" }}
                  >
                     <div className="icon">
                        {renderImg('success_icon')}
                     </div>
                     <div style={{ color: '#3C763C', fontSize: '20px', fontWeight: '500', lineHeight: '28px', textAlign: 'center', padding: '16px 0' }}>New Transaction Password Sent</div>
                     <div className="content" style={{ fontSize: '14px', fontWeight: '500', lineHeight: '22px', color: '#202020' }}>
                        Transaction Password has been mailed to {txnData.email} and a SMS has been sent to {txnData.mobile}
                     </div>
                  </div>
               }
            />}
            <GoogleRecaptchaV3
               onVerify={onVerify}
               refreshReCaptcha={refreshReCaptcha}
            />
         </div>
         <Footer />
      </div>
   )
}
export default GuestCancel;